import React from 'react';

var Print = function Print(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.961 6C9.431 6 9 6.43 9 6.961V9h6V6.961c0-.53-.43-.961-.961-.961H9.96zM17 9h1.122c1.542 0 2.855 1.374 2.855 2.815L21 15.73a1 1 0 0 1-1.003 1.006l-.936-.002.003.365c0 1.156-.669 1.916-1.9 1.9H6.821c-1.206.016-1.88-.801-1.88-1.888l-.004-.377-.924.002a1 1 0 0 1-1.002-.997L3 11.82C3 10.378 4.363 9 5.904 9H7V6.961A2.961 2.961 0 0 1 9.961 4h4.078A2.961 2.961 0 0 1 17 6.961V9zm.06 7.58l-.002-.254a96.985 96.985 0 0 1-.003-.594 1 1 0 0 1 1.003-1l.936.002-.017-2.913c0-.362-.438-.821-.855-.821H5.904c-.432 0-.904.477-.904.818l.008 2.916.921-.002a1 1 0 0 1 1.003 1A106.783 106.783 0 0 0 6.94 17h10.124l-.003-.42zM16 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

Print.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Print as icon };
export default iconHandler(Print);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Print.js
// module id = 620
// module chunks = 0